// 获取后缀名
function getUrls() {
  let host =  location.host;
  let index = host.indexOf(".");
  let otherUrls = host.substring(index+1);
  let urlStings = '.cutmall.cn,.th512.com,.2wbuy.cn'; // 16、17、18的域名后缀
  // 线上正式
  let domains = 'cutmall.cn'  //需要改变的后缀名
  if(urlStings.indexOf(otherUrls)==-1){
      domains = otherUrls
  }
  return domains
}

// 获取cookie、
function getCookie (cname) {
  let name = cname + '='
  let ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') c = c.substring(1)
    if (c.indexOf(name) != -1) return unescape(c.substring(name.length, c.length))
  }
  return ''
}

// 设置cookie,增加到vue实例方便全局调用
function setCookie(cName, value, expiredays) {
    let exdate = new Date()
    let expireday = 8
    exdate.setHours(exdate.getHours() + expireday)
        // 线下
   // let cookiestr = cName + '=' + escape(value) + (((expireday == null) ? '' : ';expires=' + exdate.toGMTString()))
        // 线上
    let domains = getUrls()
    let cookiestr = cName + '=' + escape(value) + (((expireday == null) ? '' : ';expires=' + exdate.toGMTString()) + `;domain=${domains};path=/`)
    document.cookie = cookiestr
        // 线上
   document.domain = `${domains}`;
}
// 删除cookie
function delCookie (name) {
  let exp = new Date()
  exp.setTime(exp.getTime() - 1)
  let cval = getCookie(name)
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
  }
}

function clearCookie () { // 清空cookie
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  console.log(keys)
  if (keys) {
    for (var i =  keys.length; i--;)
      document.cookie=keys[i]+'=0;expires=' + new Date( 0).toUTCString()
  }
}

// HTMLEncode
function HTMLEncode (html) {
  var temp = document.createElement('div');
  (temp.textContent != null) ? (temp.textContent = html) : (temp.innerText = html)
  var output = temp.innerHTML
  temp = null
  return output
}

// HTMLDecode
function HTMLDecode (text) {
  var temp = document.createElement('div')
  temp.innerHTML = text
  var output = temp.innerText || temp.textContent
  temp = null
  return output
}

export {
  getCookie,
  setCookie,
  delCookie,
  clearCookie,
  HTMLEncode,
  HTMLDecode,
  getUrls
}



// WEBPACK FOOTER //
// ./src/util/util.js